import ItemsList from "common/Lists/ItemsList";
import { getItem } from "common/Lists/utils";
import { ICON_TYPES } from "@shared/common/constants";
import { sharedLib } from "@shared/services/shared.service";
import { skipToken } from "@reduxjs/toolkit/query";
import { ListItem } from "common/Lists/types";

const PairsList = ({ coin, accountId, handleSelectPair }) => {
  const { data, isLoading, isSuccess } =
    sharedLib.sharedApi.portfolio.useGetPairsQuery(
      accountId && coin
        ? {
            account_id: accountId,
            asset: coin,
          }
        : skipToken
    );

  const items = data?.reduce((acc: ListItem<string>[], pair) => {
    acc.push(getItem(pair, pair));
    return acc;
  }, []);

  return (
    <ItemsList
      items={items ?? []}
      loading={isLoading}
      loaded={isSuccess}
      handleSelectItem={handleSelectPair}
      iconType={ICON_TYPES.COIN}
    />
  );
};

export default PairsList;
